import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ITransaction } from '../../api/transactions/types';

export interface ITransactionsHistoryState {
    recentTransactionId?: string;
    transactionsHistory: ITransaction[];
}

const initialState: ITransactionsHistoryState = {
    recentTransactionId: localStorage.getItem('recentTransactionId') ?? undefined,
    transactionsHistory: JSON.parse(localStorage.getItem('transactionsHistory') ?? '[]'),
};

const transactionsHistorySlice = createSlice({
    name: 'transactionsHistory',
    initialState,
    reducers: {
        addTransactionToHistory: (state, data: PayloadAction<ITransaction>): void => {
            const isTransactionAlreadyInHistory = state.transactionsHistory.some(t => t._id === data.payload._id);
            if (isTransactionAlreadyInHistory) {
                return;
            }
            state.transactionsHistory = [data.payload, ...state.transactionsHistory.slice(0, 5)];
            localStorage.setItem('transactionsHistory', JSON.stringify(state.transactionsHistory));
        },
        updateRecentTransactionId: (state, data: PayloadAction<string>): void => {
            state.recentTransactionId = data.payload;
            localStorage.setItem('recentTransactionId', data.payload);
        },
        cleanUpRecentTransaction: (state): void => {
            state.recentTransactionId = undefined;
            localStorage.removeItem('recentTransactionId');
        },
    },
});

export const { addTransactionToHistory, updateRecentTransactionId, cleanUpRecentTransaction } = transactionsHistorySlice.actions;
export const transactionsHistoryReducer = transactionsHistorySlice.reducer;
